export default function formValid() {
  return {
    require: 'form',
    link($scope, $element, $attrs, $form) {
      $scope.$watch($attrs.formValid, (isValid) => {
        $form.$setValidity('form-valid-directive', isValid);
      });
    },
  };
}
